// ─────────────────────────────────────────────────────────────────────────────
// SettingsRail — the left tab rail. Pure presentation: the page owns which tab
// is active; TABS is the single source of truth for tab order/labels/icons.
// ─────────────────────────────────────────────────────────────────────────────
import styles from "./SettingsRail.module.css";
import { IcoCompany, IcoShield, IcoLock, IcoLink, IcoBell } from "./icons";

export const TABS = [
  { key: "company",       label: "Company Profile", Icon: IcoCompany },
  { key: "roles",         label: "Admin Roles",     Icon: IcoShield  },
  { key: "security",      label: "Security",        Icon: IcoLock    },
  { key: "integrations",  label: "Integrations",    Icon: IcoLink    },
  { key: "notifications", label: "Notifications",   Icon: IcoBell    },
];

// `tabs` lets the page drop a tab the current role has no business seeing
// (Security needs user_management access, which Settings access alone doesn't
// imply). Defaults to the full set.
export default function SettingsRail({ tab, onTab, tabs = TABS }) {
  return (
    <nav className={styles.rail}>
      {tabs.map(({ key, label, Icon }) => (
        <button
          key={key}
          className={`${styles.tab} ${tab === key ? styles.tabActive : ""}`}
          onClick={() => onTab(key)}
          aria-current={tab === key ? "page" : undefined}
        >
          <span className={styles.tabIcon}><Icon/></span>
          <span className={styles.tabLabel}>{label}</span>
        </button>
      ))}
    </nav>
  );
}
